import { render, staticRenderFns } from "./AllGroups.vue?vue&type=template&id=6fad6755"
import script from "./AllGroups.vue?vue&type=script&lang=js"
export * from "./AllGroups.vue?vue&type=script&lang=js"
import style0 from "./AllGroups.vue?vue&type=style&index=0&id=6fad6755&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports